import { render, staticRenderFns } from "./ItemCountStatusInfo.vue?vue&type=template&id=72d58e56&scoped=true&"
import script from "./ItemCountStatusInfo.vue?vue&type=script&lang=js&"
export * from "./ItemCountStatusInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d58e56",
  null
  
)

export default component.exports